"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_1 = require("./styled");
var calcAspectRatio_1 = require("../ImageEditor/utils/calcAspectRatio");
var useScreenWidth_1 = require("../../../../utils/customHooks/useScreenWidth");
var AspectRatioShell = function (_a) {
    var id = _a.id, invert = _a.invert, aspectRatio = _a.aspectRatio, children = _a.children, stretchToFullHeight = _a.stretchToFullHeight, containerShape = _a.containerShape, disableImageBorder = _a.disableImageBorder, onShellPrepared = _a.onShellPrepared;
    var wrapperRef = (0, react_1.useRef)(null);
    var _b = (0, react_1.useState)({ width: 'auto', height: 'auto' }), dimensions = _b[0], setDimensions = _b[1];
    var updateDimensions = function () {
        if (wrapperRef.current) {
            if (stretchToFullHeight) {
                var newWidth_1 = wrapperRef.current.clientHeight * (0, calcAspectRatio_1.calcAspectRatio)(aspectRatio);
                setDimensions(function (prev) { return (__assign(__assign({}, prev), { width: "".concat(newWidth_1, "px") })); });
            }
            else {
                var newHeight_1 = wrapperRef.current.offsetWidth / (0, calcAspectRatio_1.calcAspectRatio)(aspectRatio);
                setDimensions(function (prev) { return (__assign(__assign({}, prev), { height: "".concat(newHeight_1, "px") })); });
            }
        }
    };
    (0, react_1.useLayoutEffect)(function () {
        updateDimensions();
        var resizeObserver = new ResizeObserver(updateDimensions);
        if (wrapperRef.current) {
            resizeObserver.observe(wrapperRef.current);
        }
        return function () { return resizeObserver.disconnect(); };
    }, [aspectRatio, stretchToFullHeight]);
    (0, react_1.useEffect)(function () {
        if (dimensions.width !== 'auto' || dimensions.height !== 'auto') {
            //means the shell is ready with the proper dimensions
            onShellPrepared && onShellPrepared(); //we use this fn. in imageEditor to trigger off the decision on toolbar style
        }
    }, [dimensions, onShellPrepared]);
    (0, useScreenWidth_1.useScreenWidth)(updateDimensions);
    return (react_1.default.createElement(styled_1.StyledAspectRatioWrapper, { id: 'StyledAspectRatioWrapper', ref: wrapperRef, width: stretchToFullHeight ? dimensions.width : "100%", height: stretchToFullHeight ? "100%" : dimensions.height, containerShape: containerShape, invert: invert, disableImageBorder: disableImageBorder }, children));
};
exports.default = AspectRatioShell;
